export default __webpack_public_path__ + "static/media/circle.f9eb8ba0.png";